<template>
    <div id="threedium"></div>
</template>

<style lang="scss">
#threedium {
    canvas {
        mix-blend-mode: darken !important;
    }
}
</style>
